export type FooterPaginationDisplay = {
  currentPage: number
  displayCount: number
  hasActiveFilters: boolean
  pageEnd: number
  pageStart: number
  resultCount: number
  totalPages: number
}

export function getClientCardFooterPagination(args: {
  currentPage: number
  displayCount: number
  filteredCount: number
  hasActiveFilters: boolean
  pageEnd: number
  pageStart: number
  totalPages: number
}): FooterPaginationDisplay {
  return {
    currentPage: args.currentPage,
    displayCount: args.displayCount,
    hasActiveFilters: args.hasActiveFilters,
    pageEnd: args.pageEnd,
    pageStart: args.pageStart,
    resultCount: args.filteredCount,
    totalPages: args.totalPages,
  }
}

export function getServerPagedCardFooterPagination(args: {
  hasActiveFilters: boolean
  pageIndex: number
  pageSize: number
  totalCount: number
}): FooterPaginationDisplay {
  const pageStart = args.pageIndex * args.pageSize
  const pageEnd = Math.min(pageStart + args.pageSize, args.totalCount)
  return {
    currentPage: args.pageIndex,
    displayCount: args.totalCount,
    hasActiveFilters: args.hasActiveFilters,
    pageEnd,
    pageStart,
    resultCount: Math.max(0, pageEnd - pageStart),
    totalPages: Math.ceil(args.totalCount / args.pageSize) || 0,
  }
}

export function getTableFooterPagination(args: {
  filteredCount: number
  hasActiveFilters: boolean
  isServerPaged: boolean
  pageIndex: number
  pageSize: number
  totalCount: number
}): FooterPaginationDisplay {
  if (args.isServerPaged) {
    return getServerPagedCardFooterPagination({
      hasActiveFilters: args.hasActiveFilters,
      pageIndex: args.pageIndex,
      pageSize: args.pageSize,
      totalCount: args.totalCount,
    })
  }
  const pageStart = args.pageIndex * args.pageSize
  return {
    currentPage: args.pageIndex,
    displayCount: args.hasActiveFilters ? args.filteredCount : args.totalCount,
    hasActiveFilters: args.hasActiveFilters,
    pageEnd: Math.min(pageStart + args.pageSize, args.filteredCount),
    pageStart,
    resultCount: args.filteredCount,
    totalPages: Math.ceil(args.filteredCount / args.pageSize),
  }
}
